import React, { Component } from 'react';

import TextInput from '../../../ZUILib/TextInput';
import InputButton from '../../../ZUILib/InputButton';
import commonUtil from '../../../../utils/commonUtil';

const constChannels = commonUtil.getClientConstForChannel();
const channel = commonUtil.getChannel();
class AddZipCode extends Component {
  state = { validLabel: null }

  textFieldValidation = ({ value }) => {
    const textCodeStateConfig = [
      {
        functionRef: commonUtil.isValueAvailable,
        funcData: [value.getValue()],
        errorMessage: 'Ingresa un dato válido',
      },
    ];

    const textCodeDigitsLength = [
      {
        functionRef: commonUtil.validateLengthDigitsCP,
        funcData: [value.getValue()],
        errorMessage: 'Ingresa un dato válido',
      },
    ];

    const textFieldValid = commonUtil.validateTextInput(textCodeStateConfig, value, null);
    const textFieldCodeValid = commonUtil.validateTextInput(textCodeDigitsLength, value, null);

    this.setState({ validLabel: (textFieldValid && textFieldCodeValid) });

    if (textFieldValid && textFieldCodeValid) return true;
    return false;
  };

  sendZipData = () => {
    const value = this.selectZipOrState.getValue();
    if (this.textFieldValidation({ value: this.selectZipOrState })) {
      this.props.callSearchZipStateService(value);
    }
  }

  handleValidationText = (e) => {
    const _char = String.fromCharCode(e.charCode);
    if (!(/^[a-zA-ZáéíóúñüÁÉÍÓÚÑÜ \s\d]+$/.test(_char))) {
      e.preventDefault();
    }
  }

  handleOnChangeBtn = () => {}

  handlePasteValidation = (event) => {
    const text = event.clipboardData.getData('Text');
    const alphaNumericValue = text ? text.replace(/[^a-zA-ZáéíóúñüÁÉÍÓÚÑÜ \s\d]/gi, '') : '';
    if (text !== alphaNumericValue) {
      event.preventDefault();
    }
  }

  render() {
    const { requiredLabel } = this.props;

    const device = (channel === constChannels.WAP);
    const style = {
      width: device ? '240px' : '280px',
      border: requiredLabel ? '1px solid #f00' : '1px solid #d8d8d8',
      borderRadius: '5px',
      height: '44px',
    };

    return (
      <div className="alignmentRow addZipOrCodeState">
        <TextInput
          className="inputMaterial p-l-10"
          labelClassName="placeHolderMaterial"
          requiredLabel={this.state.validLabel === true ? requiredLabel : null}
          isErrorMsg={requiredLabel}
          htmlId="zipCodeStateId"
          name="zipCodeStateId"
          label="C.P. Ciudad o Tienda"
          style={style}
          required="true"
          star="*"
          onChange={(e) => { this.handleOnChangeBtn(e); }}
          onPaste={(e) => { this.handlePasteValidation(e); }}
          onKeyPress={(e) => { this.handleValidationText(e); }}
          ref={selectZipOrState => this.selectZipOrState = selectZipOrState}
        />

        <InputButton
          buttonAttr={{
            classname: 'btnPrimary size-Full',
            cssStyle: { width: '246px', borderRadius: 5, height: '44px', margin: 0,backgroundColor:'#0F4DBC' },
            id: 'btnHandleSearch',
            name: 'searchZipOrState',
            type: 'button',
            value: 'Buscar',
            autoFocus: false,
            onClickHandler: this.sendZipData,
          }}
        />
      </div>
    );
  }
}

export default AddZipCode;
